import { ResolverType } from './editorComponents';

function camelToUpperSnakeCase(input: string): string {
  return input
    .replace(/([a-z])([A-Z])/g, '$1_$2')
    .toUpperCase();
}

const resolverMapper: { [Key in keyof ResolverType]: string } = {
  Group: 'Group',
  Text: 'TEXT',
  Image: 'IMAGE',
  Link: 'LINK',
  Coupon: 'Coupon',
  ProductList: 'ProductList',
  TodayDealProductList: 'TodayDealProductList',
  Tab: 'Tab',
  TabItem: 'TabItem',
  TabButton: 'TabButton',
  TabContent: 'TabContent',
  AnchorTarget: 'AnchorTarget',
  Carousel: 'Carousel',
  Accordion: 'Accordion',
  AccordionButton: 'AccordionButton',
  AccordionContent: 'AccordionContent',
  Countdown: 'Countdown',
  ImageTabCarousel: 'ImageTabCarousel',
  ImageTabCarouselItem: 'ImageTabCarouselItem',
  ImageMapLink: 'ImageMapLink',
  ImageMapBraze: 'ImageMapBraze',
  ProductListCarousel: 'ProductListCarousel',
  StickyTab: 'StickyTab',
  StickyTabItem: 'StickyTabItem',
  TextTabItem: 'TextTabItem',
};

const customResolverNames: { [key: string]: string } = {
  ImageTabCarousel: 'IMAGE_CAROUSEL',
  ImageTabCarouselItem: 'IMAGE_CAROUSEL_ITEM',
  ProductListCarousel: 'PRODUCT_CAROUSEL',
  TodayDealProductList: 'EVENT_PRODUCT_LIST',
};


/** 로깅시 section_id를 지정한 값으로 쓰기 위해 커스텀해줍니다. */
export const SECTION_ID_MAPPER: Record<string, string> = Object.keys(resolverMapper).reduce<Record<string, string>>(
  (map, key) => {
    const defaultName = camelToUpperSnakeCase(key);
    map[key] = customResolverNames[key] || defaultName;
    return map;
  }, {},
);
